'use strict';

function _Paths() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  this.paths = {
    maintenance: '/account-maintenance',
    signup: {
      verify: '/member/dashboard/verify-account',
      product_interests: '/member/dashboard/onboarding/product-interests',
      credit_request_reasons: '/member/dashboard/onboarding/credit-request',
      legal_name: '/member/dashboard/onboarding/legal-name',
      dob: '/member/dashboard/onboarding/dob',
      address: '/member/dashboard/onboarding/address',
      phone: '/member/dashboard/onboarding/phone',
      residential_status: '/member/dashboard/onboarding/residential-status',
      residential_details: '/member/dashboard/onboarding/residential-details',
      employment_information: '/member/dashboard/onboarding/employment-information',
      provide_consent: '/member/dashboard/onboarding/provide-consent',
      create_profile: '/member/dashboard/profile-info',
      create_profile_step2: '/member/dashboard/onboarding/create-profile',
      kyc_questions: '/member/dashboard/kyc-questions',
      kyc_partner_down: '/member/dashboard/kyc-partner-down',
      declined: {
        underage: '/member/dashboard/declined/underage',
        province: '/member/dashboard/declined/province',
        province_underage: '/member/dashboard/declined/province-underage',
        profile_not_found: '/member/dashboard/declined/profile-not-found',
        kyc_denied: '/member/dashboard/declined/kyc-denied',
        kyc_failed: '/member/dashboard/declined/kyc-failed',
        kyc_first_attempt: '/member/dashboard/declined/kyc-first-attempt',
        kyc_last_attempt: '/member/dashboard/declined/kyc-last-attempt'
      },
      account_already_exists: '/member/dashboard/account-already-exists',
      credit_check: '/member/dashboard/soft-credit-check',
      lender_licence: '/member/dashboard/licence-info',
      unrecoverable_error: '/member/dashboard/unrecoverable-error'
    },
    account: {
      dashboard: '/member/dashboard/home',
      interstitial: '/member/dashboard/home/interstitial',
      crypto_referral_interstitial: '/member/dashboard/home/interstitial-crypto-referral',
      activation: '/accounts/activation',
      settings: '/member/dashboard/account',
      notification_centre: '/member/dashboard/home/notification-centre',
      referral_panel: '/member/dashboard/home/referral-panel'
    },
    card: {
      interstitial: '/member/dashboard/card/interstitial',
      dashboard: '/member/dashboard/card',
      overview: '/member/dashboard/card/overview',
      phone_verification: '/member/dashboard/card/order-card/phone-verification',
      order_card: {
        out_of_stock: '/member/dashboard/card/order-card/out-of-stock',
        choose_design: '/member/dashboard/card/order-card/choose-design',
        choose_design_product: '/member/dashboard/card/order-card/choose-design-product',
        set_pin: '/member/dashboard/card/order-card/set-pin',
        confirm_address: '/member/dashboard/card/order-card/confirm-address',
        checkout: '/member/dashboard/card/order-card/checkout',
        menu: '/member/dashboard/card/order-card'
      },
      replace_design: {
        out_of_stock: '/member/dashboard/card/replace-design/out-of-stock',
        choose_design: '/member/dashboard/card/replace-design/choose-design',
        choose_design_product: '/member/dashboard/card/replace-design/choose-design-product',
        set_pin: '/member/dashboard/card/replace-design/set-pin',
        confirm_address: '/member/dashboard/card/replace-design/confirm-address',
        checkout: '/member/dashboard/card/replace-design/checkout',
        menu: '/member/dashboard/card/replace-design'
      },
      replace_card: {
        out_of_stock: '/member/dashboard/card/replace-card/out-of-stock',
        choose_design: '/member/dashboard/card/replace-card/choose-design',
        choose_design_product: '/member/dashboard/card/replace-card/choose-design-product',
        set_pin: '/member/dashboard/card/replace-card/set-pin',
        confirm_address: '/member/dashboard/card/replace-card/confirm-address',
        checkout: '/member/dashboard/card/replace-card/checkout',
        menu: '/member/dashboard/card/replace-card'
      },
      activate_card: {
        activate: '/member/dashboard/card/activate/card-id',
        pin_reminder: '/member/dashboard/card/activate/pin-reminder',
        view_pin: '/member/dashboard/card/activate/view-pin',
        find_pin: '/member/dashboard/card/activate/find-pin',
        confirmation: '/member/dashboard/card/activate/confirmation'
      },
      load_card: {
        qualification: '/member/dashboard/card/load/qualification',
        select_bank: '/member/dashboard/card/load',
        add_bank: '/member/dashboard/card/load/add-bank',
        add_bank_success: '/member/dashboard/card/load/add-bank-success',
        add_bank_error: '/member/dashboard/card/load/add-bank-error',
        vdtransfer: '/member/dashboard/card/load/transfer',
        vdtransfer_start_date: '/member/dashboard/card/load/transfer-start-date',
        vdtransfer_details: '/member/dashboard/card/load/transfer-details',
        edit_vdtransfer: '/member/dashboard/card/edit/transfer',
        edit_vdtransfer_start_date: '/member/dashboard/card/edit/transfer-start-date',
        edit_vdtransfer_details: '/member/dashboard/card/edit/transfer-details',
        edit_vdtransfer_success: '/member/dashboard/card/edit/transfer-success',
        etransfer: '/member/dashboard/card/load/etransfer',
        etransfer_details: '/member/dashboard/card/load/etransfer-details',
        vdtransfer_success: '/member/dashboard/card/load/transfer-success',
        vdtransfer_success_recurring: '/member/dashboard/card/load/transfer-recurring-success',
        vdtransfer_failure: '/member/dashboard/card/load/transfer-failure',
        vdtransfer_failure_pending: '/member/dashboard/card/load/transfer-adhoc-failure-pending',
        vdtransfer_failure_timeout: '/member/dashboard/card/load/transfer-failure-timeout',
        vdtransfer_failure_recurring: '/member/dashboard/card/load/transfer-recurring-failure',
        vdtransfer_challenge_failure: '/member/dashboard/card/load/transfer-incomplete'
      },
      settings: '/member/dashboard/card/settings',
      settings_auto_transfer: {
        manage_auto_transfer: '/member/dashboard/card/settings/auto-transfer',
        skip_transfer: '/member/dashboard/card/settings/auto-transfer/skip-transfer',
        skip_transfer_success: '/member/dashboard/card/settings/auto-transfer/skip-transfer-success'
      },
      settings_load_card: {
        select_bank: '/member/dashboard/card/settings/select-bank',
        add_bank: '/member/dashboard/card/settings/add-bank',
        add_bank_success: '/member/dashboard/card/settings/add-bank-success',
        add_bank_error: '/member/dashboard/card/settings/add-bank-error',
        add_bank_unsupported: '/member/dashboard/card/settings/add-bank-unsupported',
        vdtransfer_failure_timeout: '/member/dashboard/card/settings/transfer-failure-timeout'
      },
      settings_manage_bank_account: {
        manage_bank_account: '/member/dashboard/card/settings/manage-bank-account',
        delete_bank_account_success: '/member/dashboard/card/settings/manage-bank-account/delete-success'
      },
      spending_goal: {
        prompt: '/member/dashboard/card/goal/prompt',
        set: '/member/dashboard/card/goal/set',
        confirmation: '/member/dashboard/card/goal/confirmation'
      },
      failed_auto_transfer: '/member/dashboard/card/transfer-recurring-failure',
      analysis: '/member/dashboard/card/analysis',
      carbon_walkthrough: '/member/dashboard/card/carbon-walkthrough',
      carbon_lifetime: '/member/dashboard/card/carbon-lifetime',
      bitcoin_cashback_activate: '/member/dashboard/card/activate-bitcoin-cashback',
      bitcoin_cashback_lifetime: '/member/dashboard/card/bitcoin-cashback-lifetime'
    },
    loans: {
      fs: '/portal/dashboard',
      router: '/member/dashboard/loans',
      interstitial: '/member/dashboard/loans/interstitial',
      preapproval: '/member/dashboard/loans/preapproval',
      paid_off: '/member/dashboard/loans/paid-off',
      overview: '/member/dashboard/loans/overview',
      offers: '/member/dashboard/loans/offers',
      offer_refresh_review_info: '/member/dashboard/loans/request/review-info',
      offer_refresh_additional_info: '/member/dashboard/loans/request/additional-info',
      offer_refresh_select_amount: '/member/dashboard/loans/request/select-amount',
      application: '/member/dashboard/loans/apply',
      application_status: '/member/dashboard/loans/application/status',
      application_flow_start: '/member/dashboard/loans/application/start',
      application_flow_phone_verification: '/member/dashboard/loans/application/phone-verification',
      application_flow_employment: '/member/dashboard/loans/application/employment',
      application_flow_income: '/member/dashboard/loans/application/income',
      application_flow_income_weekly: '/member/dashboard/loans/application/income/weekly',
      application_flow_income_bi_weekly: '/member/dashboard/loans/application/income/bi-weekly',
      application_flow_income_monthly: '/member/dashboard/loans/application/income/monthly',
      application_flow_income_semi_monthly: '/member/dashboard/loans/application/income/semi-monthly',
      application_flow_loan_customization: '/member/dashboard/loans/application/loan-customization',
      application_flow_review: '/member/dashboard/loans/application/review',
      application_flow_complete: '/member/dashboard/loans/application/complete',
      application_flow_complete_error: '/member/dashboard/loans/application/complete-error',
      application_flow_bank: '/member/dashboard/loans/application/banking',
      application_flow_bank_introduction: '/member/dashboard/loans/application/bank-introduction',
      application_flow_connect_bank: '/member/dashboard/loans/application/connect-bank',
      application_flow_connect_to_bank_service: '/member/dashboard/loans/application/connect-to-bank-service',
      application_flow_email_bank: '/member/dashboard/loans/application/email-bank',
      application_flow_retrieve_bank: '/member/dashboard/loans/application/retrieve-bank',
      phone_verification: '/member/dashboard/loans/phone-verification',
      bank_verification: '/member/dashboard/loans/apply/bank-statement/verify',
      bank_verification_error: '/member/dashboard/loans/apply/bank-statement/error',
      manitoba_liquid_license: '/member/dashboard/loans/manitoba-liquid-license',
      manitoba_mini_license: '/member/dashboard/loans/manitoba-mini-license',
      product: {
        liquid: '/member/dashboard/loans/liquid',
        mini: '/member/dashboard/loans/mini',
        zip: '/member/dashboard/loans/zip'
      },
      liquid: {
        add_payment: {
          type_selection: '/member/dashboard/loans/liquid/add-payment',
          additional: {
            date_selection: '/member/dashboard/loans/liquid/add-payment/additional-payment-date',
            amount_selection: '/member/dashboard/loans/liquid/add-payment/additional-payment-amount',
            review: '/member/dashboard/loans/liquid/add-payment/additional-payment-review',
            confirm_success: '/member/dashboard/loans/liquid/add-payment/additional-payment-success',
            confirm_failed: '/member/dashboard/loans/liquid/add-payment/additional-payment-failed'
          },
          pay_in_full: '/member/dashboard/loans/liquid/add-payment/pay-in-full'
        }
      }
    },
    crypto: {
      interstitial: '/member/dashboard/crypto/interstitial',
      create_account: '/member/dashboard/crypto/create-account',
      watch: '/member/dashboard/crypto',
      mobile: '/member/dashboard/crypto/use-the-app',
      crypto_transfer: '/member/dashboard/crypto/crypto-transfer',
      crypto_transfer_coinsquare: '/member/dashboard/crypto/crypto-transfer-coinsquare',
      crypto_transfer_coinsquare_complete: '/member/dashboard/crypto/crypto-transfer-coinsquare-complete',
      buy: '/member/dashboard/crypto/buy',
      sell: '/member/dashboard/crypto/sell',
      fund_begin: '/member/dashboard/crypto/fund-begin',
      fund: '/member/dashboard/crypto/fund',
      fund_etransfer: '/member/dashboard/crypto/fund-etransfer',
      fund_etransfer_details: '/member/dashboard/crypto/fund-details',
      fund_wire_transfer: '/member/dashboard/crypto/fund-wire-transfer',
      fund_wire_consent: '/member/dashboard/crypto/fund-wire-transfer-consent',
      fund_wire_details: '/member/dashboard/crypto/fund-wire-details',
      fund_wire_upload: '/member/dashboard/crypto/wire-receipt',
      fund_wire_complete: '/member/dashboard/crypto/wire-complete',
      withdraw: '/member/dashboard/crypto/withdraw',
      settings: '/member/dashboard/crypto/settings',
      tx_history: '/member/dashboard/crypto/activity',
      bank_verification: '/member/dashboard/crypto/verify-bank',
      intent: '/member/dashboard/crypto/fund-intent-of-use',
      terms: '/member/dashboard/crypto/fund-terms-and-conditions',
      verify_bank_complete: '/member/dashboard/crypto/verify-bank-complete',
      verify_bank_error: '/member/dashboard/crypto/verify-bank-error',
      bankSetupDashboard: {
        bank_required: '/member/dashboard/crypto/bank-required',
        bank_info: '/member/dashboard/crypto/bank-info',
        bank_info_confirm: '/member/dashboard/crypto/bank-info-confirm',
        bank_edit: '/member/dashboard/crypto/bank-edit',
        bank_confirmation: '/member/dashboard/crypto/bank-confirmation',
        bank_pending: '/member/dashboard/crypto/bank-pending',
        bank_error: '/member/dashboard/crypto/bank-error',
        bank_verification: '/member/dashboard/crypto/verify-bank',
        bank_verification_complete: '/member/dashboard/crypto/verify-bank-complete',
        bank_verification_error: '/member/dashboard/crypto/verify-bank-error'
      },
      bankSetupSettings: {
        bank_required: '/member/dashboard/crypto/settings/bank-required',
        bank_info: '/member/dashboard/crypto/settings/bank-info',
        bank_info_confirm: '/member/dashboard/crypto/settings/bank-info-confirm',
        bank_edit: '/member/dashboard/crypto/settings/bank-edit',
        bank_confirmation: '/member/dashboard/crypto/settings/bank-confirmation',
        bank_pending: '/member/dashboard/crypto/settings/bank-pending',
        bank_error: '/member/dashboard/crypto/settings/bank-error',
        bank_verification: '/member/dashboard/crypto/settings/verify-bank',
        bank_verification_complete: '/member/dashboard/crypto/settings/verify-bank-complete',
        bank_verification_error: '/member/dashboard/crypto/settings/verify-bank-error'
      }
    },
    rewards: {
      side_tray: '/member/dashboard/rewards',
      cashback: '/member/dashboard/rewards/cashback'
    },
    wealth: {
      dashboard: '/member/dashboard/wealth',
      interstitial: '/member/dashboard/wealth/interstitial',
      educational: '/member/dashboard/wealth/educational'
    },
    credit_score: {
      dashboard: '/member/dashboard/credit-score',
      interstitial: '/member/dashboard/credit-score/interstitial',
      educational: '/member/dashboard/credit-score/educational'
    },
    mortgage: {
      dashboard: '/member/dashboard/mortgage'
    },
    emt: {
      crypto: {
        fund: '/member/dashboard/crypto/fund',
        amount: '/member/dashboard/crypto/fund-emt',
        status: '/member/dashboard/crypto/fund-emt-status',
        request: '/member/dashboard/crypto/fund-emt-request',
        processing: '/member/dashboard/crypto/fund-emt-processing',
        complete: '/member/dashboard/crypto/fund-emt-complete',
        dashboard: '/member/dashboard/crypto'
      }
    },
    'tray-order-card': 'card/tray-order-card',
    'tray-activate-card': 'card/tray-activate-card',
    'tray-load-card': 'card/tray-load-card'
  };

  // mappings used with contentful driven configurations (shared by all clients)
  Product.shortcutMappings = {
    'main-dashboard': this.paths.account.dashboard,
    'main-dashboard-interstitial': this.paths.account.interstitial,
    'main-dashboard-crypto-tiers-referral-interstitial': this.paths.account.crypto_referral_interstitial,
    'climate-walkthrough': this.paths.card.carbon_walkthrough,
    'credit-score-interstitial': this.paths.credit_score.interstitial,
    'credit-score-overview': this.paths.credit_score.dashboard,
    'credit-score-education': this.paths.credit_score.educational,
    'spend-interstitial': this.paths.card.interstitial,
    'spend-overview': this.paths.card.dashboard,
    'spend-overview-marketing': this.paths.card.overview,
    'spend-walkthrough': '/member/dashboard/card/walkthrough',
    'spend-education': '/member/dashboard/card/educational',
    'spend-fund-flow': this.paths.card.load_card.select_bank,
    'spend-activate-card': this.paths.card.overview,
    'spend-lifetime-cashback': this.paths.card.bitcoin_cashback_lifetime,
    'money-interstitial': this.paths.loans.interstitial,
    'money-overview': this.paths.loans.preapproval,
    'money-education': '/member/dashboard/loans/educational',
    'mortgage-interstitial': '/member/dashboard/mortgage/interstitial',
    'mortgage-overview': '/member/dashboard/mortgage',
    'wealth-interstitial': this.paths.wealth.interstitial,
    'wealth-overview': this.paths.wealth.dashboard,
    'wealth-education': this.paths.wealth.educational,
    'crypto-overview': this.paths.crypto.watch,
    'account-settings': this.paths.account.settings,
    'spend-carbon-offsets-are-awesome': this.paths.card.carbon_lifetime,
    'spend-carbon-offsets-are-awesome-no-card': this.paths.card.overview,
    'lifetime-bitcoin-cashback-referral': this.paths.account.referral_panel,
    'referral-share-screen': this.paths.account.referral_panel,
    'bitcoin-cashback-activate-spend': this.paths.card.dashboard,
    'bitcoin-cashback-monthly-earned': this.paths.rewards.cashback,
    'rewards-benefit-gallery': this.paths.rewards.side_tray,
    'visa-direct-load-card': this.paths.card.load_card.select_bank
  };

  this.init = function () {};
  this.initAllReady = function () {};
}